import RoomCards from "./components/RoomCards/RoomCards"
import Screen from "src/shared/components/layout/screen/Screen"
import "./Home.css"
import DrawerNavigator from "./room-detail/drawer"
import SkeletonCards from "./components/SkeletonCards/SkeletonCards"
import { useSelector } from "react-redux"
import { RootState } from "src/store/store"
import HeaderTimer from "./sections/HeaderTimer/HeaderTimer"
import { CurrentdateProvider } from "src/shared/providers/CurrentdateProvider"
import { useState } from "react"
import { ROOMS_GRID_SKELETON } from "src/shared/constants/localStorage"

function getSavedRows(): number {
    try {
        return JSON.parse(localStorage.getItem(ROOMS_GRID_SKELETON) || "null")?.x || 0
    } catch {
        return 0
    }
}

function Home(): JSX.Element {
    const { rooms, roomsDimensions, isLoading } = useSelector((root: RootState) => root.rooms)
    // El margen se reparte entre las filas de la cuadrícula, así que sin filas conocidas el
    // divisor cae a 1 y el margen empuja las cards fuera del viewport (se pierde la barra
    // inferior). Mientras llegan las habitaciones se usan las filas de la última carga.
    const [savedRows] = useState(getSavedRows)
    const rows = roomsDimensions?.x || savedRows
    const marginBottom = rows ? `calc(calc(80dvh - 240px) / ${rows * 4})` : "20px"

    return (
        <CurrentdateProvider>
            <Screen className="home-screen" staticWidth={false}>
                <div className="home-screen__header__wrapper" style={{ marginBottom }}>
                    <div className="home-screen__header">
                        <h2 className="screen__head__title">Habitaciones</h2>
                        <HeaderTimer />
                    </div>
                </div>
                {isLoading || !rooms.length ? <SkeletonCards /> : <RoomCards />}
                <DrawerNavigator />
            </Screen>
        </CurrentdateProvider>
    )
}

export default Home
